import { render, staticRenderFns } from "./TaxResidencyCN.vue?vue&type=template&id=7c0e9bac"
import script from "./TaxResidencyCN.vue?vue&type=script&lang=js"
export * from "./TaxResidencyCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports